<div
  [attr.data-cid]="id"
  class="relative z-[150]"
  aria-labelledby="slide-over-title"
  role="dialog"
  aria-modal="true"
>
  <!-- Backdrop -->
  <div
    #drawerBackdrop
    [@backdropState]="isOpen() ? 'open' : 'closed'"
    class="pointer-events-auto fixed inset-0 z-[90] bg-neutral-low-dark opacity-0"
    [ngClass]="{
      'bg-opacity-25': drawerIndex() > 0,
      'bg-opacity-50': drawerIndex() === 0
    }"
  ></div>

  <!-- Drawer Container -->
  <div
    #drawerContent
    class="pointer-events-auto fixed inset-y-0 z-[95] flex h-full w-screen"
    [ngClass]="{
      'sm:max-w-sm': size() === 'sm',
      'sm:max-w-md': size() === 'md',
      'sm:max-w-2xl': size() === 'lg',
      'right-0': position() === 'right',
      'left-0': position() === 'left',
      '-translate-x-full': position() === 'left',
      'translate-x-full': position() === 'right'
    }"
    [attr.data-drawer-position]="position()"
    [attr.data-drawer-index]="drawerIndex()"
    [@drawerState]="isOpen() ? 'open-' + position() : 'closed-' + position()"
    (@drawerState.start)="onTransitionStart($event)"
    (@drawerState.done)="onTransitionEnd($event)"
  >
    <div
      class="flex h-full w-full flex-col overflow-y-hidden pb-4 pt-6 shadow-xl"
      [ngClass]="bgColor()"
    >
      <!-- Header -->
      <div class="px-4 sm:px-6">
        <div
          class="flex gap-2"
          [ngClass]="{
            'items-center justify-between': title() || description(),
            'items-start justify-end': !title() && !description()
          }"
        >
          @if (title() || description()) {
            <div class="flex-auto">
              @if (title()) {
                <h2
                  class="text-base font-medium leading-6 text-neutral-low-pure"
                  [ngClass]="{
                    'text-neutral-low-pure': theme() === 'default',
                    'text-brand-primary-pure': theme() === 'primary',
                    'text-brand-secondary-pure': theme() === 'secondary',
                    'text-brand-tertiary-pure': theme() === 'tertiary'
                  }"
                  id="slide-over-title"
                >
                  {{ title() }}
                </h2>
              }

              @if (description()) {
                <p class="text-sm text-neutral-low-medium">
                  {{ description() }}
                </p>
              }
            </div>
          }

          <!-- Close Button -->
          <div class="ml-3 flex h-7 items-center">
            <button
              type="button"
              class="relative rounded-md bg-transparent ring-brand-primary-light transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2"
              [ngClass]="closeButtonColor()"
              (click)="handleClose()"
            >
              <span class="absolute -inset-2.5"></span>
              <span class="sr-only">Close panel</span>
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Content -->
      @if (component()) {
        <div class="relative mt-6 flex-1 overflow-y-auto px-4 sm:px-6">
          <ng-container
            *ngComponentOutlet="component(); injector: dynamicComponentInjector"
          />
        </div>
      }
    </div>
  </div>
</div>
